/* IMPORTANT! This mixin is also used in the widget. */

import Vue from "vue";

export default {
  methods: {
    setQuestions(chosenActivityIds) {
      if (!this.ticket.hasOwnProperty("possible_questions")) return;

      const questions = this.ticket.possible_questions.filter(question => this.hasQuestion(question, chosenActivityIds));

      Vue.set(this, "questions", questions);
    },

    hasQuestion(question, chosenActivityIds) {
      return this.isUnconditionalQuestion(question) ||
             this.isQuestionTriggeredByAnswer(question, chosenActivityIds) ||
             this.isQuestionTriggeredByChosenOptionalActivity(question, chosenActivityIds);
    },

    isUnconditionalQuestion(question) {
      return this.ticket.unconditional_question_ids.includes(question.id);
    },

    isQuestionTriggeredByAnswer(question, chosenActivityIds) {
      return this.ticket.question_triggers.some(questionTrigger => {
        if(this.answers && questionTrigger.triggerable_question_ids.includes(question.id)) {
          let answer = Object.values(this.answers).find(answer => answer.question_id == questionTrigger.question_id);
          if(answer) {
            let triggeringQuestion = this.ticket.possible_questions.find(question => question.id == questionTrigger.question_id);

            // Return false if triggering question is also a conditional question but it has not been triggered
            if(!this.isUnconditionalQuestion(triggeringQuestion) && !this.hasQuestion(triggeringQuestion, chosenActivityIds)) {
              return false;
            }

            let responses = this.getResponses(answer);
            let hasMatchingResponses = responses && responses.filter(response => questionTrigger.responses.includes(response)).length > 0;
            return (questionTrigger.operator == "equal_to" && hasMatchingResponses) ||
                   (questionTrigger.operator == "not_equal_to" && !hasMatchingResponses && responses.length > 0);
          }
         }
      });
    },

    isQuestionTriggeredByChosenOptionalActivity(question, chosenActivityIds) {
      return chosenActivityIds.some(chosenActivityId => question.public_optional_activity_ids.includes(chosenActivityId));
    },

    getResponses(answer) {
      let responses = answer["primary_response"] || answer["alternate_response"]
      if(!responses) {
        return;
      } else if(!Array.isArray(responses)) {
        return Array(responses);
      } else {
        return responses;
      }
    },
  },
};
